import { Dispatch } from '@reduxjs/toolkit'
import {
    ChartViewKey,
    MULTIPANE_FULLSCREEN_MODE_ID,
    OPTION_CHAIN_TABLE_ID,
    ViewType,
} from '../../assets/constants'
import { setMultiPaneFullScreen } from '../../actions/common.actions'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import { AppContextType } from '../../App'

const MULTI_PANE_VIEWS = new Set<ViewType>([
    ViewType.CHART,
    ViewType.OPEN_INTEREST,
    ViewType.OPEN_INTEREST_CHANGE,
    ViewType.MULTI_STRIKES_CHART,
])

export const getFullscreenTargetId = (view: ViewType | null): string | null => {
    if (view === ViewType.OPTION_CHAIN) {
        return OPTION_CHAIN_TABLE_ID
    }
    if (view && MULTI_PANE_VIEWS.has(view)) {
        return MULTIPANE_FULLSCREEN_MODE_ID
    }
    return document.getElementById(MULTIPANE_FULLSCREEN_MODE_ID)
        ? MULTIPANE_FULLSCREEN_MODE_ID
        : document.getElementById(OPTION_CHAIN_TABLE_ID)
          ? OPTION_CHAIN_TABLE_ID
          : null
}

export const toggleAppFullScreen = (
    dispatch: Dispatch,
    appContext: AppContextType,
    view: ViewType | null,
    source: 'keyboard' | 'quick-search' = 'keyboard'
) => {
    const targetId = getFullscreenTargetId(view)
    const usesMultiPaneState = targetId === MULTIPANE_FULLSCREEN_MODE_ID

    if (!document.fullscreenElement) {
        const element = targetId ? document.getElementById(targetId) : null
        if (!element) return
        AnalyticsManager.logEvent('Show Full Screen', { source })
        element
            .requestFullscreen()
            .then(() => {
                if (usesMultiPaneState) {
                    dispatch(setMultiPaneFullScreen(true))
                }
            })
            .catch((err) => console.error(`Error entering fullscreen: ${err.message}`))
        return
    }

    AnalyticsManager.logEvent('Exit Full Screen', { source })
    document
        .exitFullscreen()
        .then(() => {
            if (usesMultiPaneState) {
                dispatch(setMultiPaneFullScreen(false))
            }
            const element = document.getElementById(MULTIPANE_FULLSCREEN_MODE_ID)
            if (element) {
                element.style.removeProperty('height')
                element.style.removeProperty('overflow')
            }
            const chart = appContext.getMultiStrikeChart(ChartViewKey.MULTI_STRIKES_CHART)
            const chartContainer = chart?.container
            if (chart?.chartApi && chartContainer) {
                chart.chartApi.resize(chartContainer.clientWidth, chartContainer.clientHeight, true)
            }
        })
        .catch((err) => console.error(`Error exiting fullscreen: ${err.message}`))
}
